import type { ReactElement } from "react";

import { MessagePage } from "../../components/message-page.js";
import { useApiForm } from "../../forms/use-api-form.js";

/**
 * 招待を受けたのとは別のアカウントでログインしているとき（<c>/Error/NeedsLogout</c>）。
 *
 * 招待の承諾（<c>/api/tenants/{契約}/users/register</c>）がここへ送る。
 * <b>ログアウトは API へ送る</b>（ヘッダーのログアウトと同じ口）。移った先は API が決める。
 */
export function NeedsLogoutPage(): ReactElement {
    const form = useApiForm("/api/account/logout");

    return (
        <MessagePage
            title="ログアウトが必要です"
            actions={(
                <form method="post" noValidate onSubmit={form.onSubmit}>
                    <button type="submit" className="btn-primary" disabled={form.busy}>ログアウトする</button>
                </form>
            )}
        >
            ご招待を受けたアカウントとは別のアカウントでログインしています。<br />
            一度ログアウトしてから、招待メールのリンクを開き直してください。
        </MessagePage>
    );
}
